import { render } from "./EditWalletModal.vue?vue&type=template&id=62947cf7&scoped=true"
import script from "./EditWalletModal.vue?vue&type=script&lang=js"
export * from "./EditWalletModal.vue?vue&type=script&lang=js"

import "./EditWalletModal.vue?vue&type=style&index=0&id=62947cf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62947cf7"]])

export default __exports__